module.exports = __webpack_public_path__ + "static/media/clearpay_badge.a897414b.svg";